import get from 'lodash/get';
import compact from 'lodash/compact';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import quickResultsMapper from '@Services/PageTitle/Mappers/QuickResults';
import {
  projectMapper as retrosynthesisProjectMapper,
  routeMapper as retrosynthesisRouteMapper,
} from '@Services/PageTitle/Mappers/Retrosynthesis';
import { heatmapMapper, resultsMapper } from '@Services/PageTitle/Mappers/Results';
import { paths } from '@AppRoutes/constants';

const brandName = 'Reaxys';

// Maps to path
const ReactRouteMapper = {
  // Quick search
  [paths.SEARCH]: () => ({
    title: 'Search substances, reactions, documents, and bioactivity data',
    pageName: 'Quick search',
  }),
  // Quick results
  [paths.PREVIEW]: quickResultsMapper,
  // Query builder
  [paths.ADVANCED]: () => ({
    title: 'Build a query by using the fields, forms, and history',
    pageName: 'Query builder',
  }),
  [paths.STRUCTURE_EDITOR]: () => ({
    pageName: 'Draw a target molecule or Insert structure from its name',
  }),
  // Alerts
  [paths.ALERTS]: () => ({
    title: 'Saved alert',
    pageName: 'Alerts',
  }),
  // About
  [paths.ABOUT_CONTENT]: () => ({
    pageName: 'About Reaxys',
  }),
  // Login
  [paths.LOGIN]: () => ({
    title: 'Account',
    pageName: 'Sign in',
  }),
  [paths.LOGIN_INSTITUTION]: () => ({
    title: 'Institution',
    pageName: 'Sign in',
  }),
  // Register
  [paths.PRIVATE_REGISTER]: () => ({
    title: 'Account',
    pageName: 'Register',
  }),
  // Results
  [paths.RESULTS]: resultsMapper,
  // Bioactivity visualization
  [paths.HEATMAP]: heatmapMapper,
  // History
  [paths.HISTORY_RECENT]: () => ({
    title: 'Recent searches',
    pageName: 'History',
  }),
  [paths.HISTORY_SAVED]: () => ({
    title: 'Saved searches',
    pageName: 'History',
  }),
  // Profile
  [paths.PROFILE_ACCOUNT]: () => ({
    title: 'Account',
    pageName: 'Profile',
  }),
  [paths.PROFILE_PROFILE]: () => ({
    title: 'Profile',
    pageName: 'Profile',
  }),
  [paths.PROFILE_PREFERENCES]: () => ({
    title: 'Profile preferences',
    pageName: 'Profile',
  }),
  // Retrosynthesis
  [RsRoute.DRAW_STRUCTURE]: () => ({
    title: 'Draw a target molecule or Insert structure from its name for retrosynthesis',
    pageName: 'Retrosynthesis',
  }),
  [RsRoute.PROJECTS_LIST]: () => ({
    pageName: 'My Retrosynthesis projects',
  }),
  [RsRoute.PROJECT]: retrosynthesisProjectMapper,
  [RsRoute.PROJECT_ROUTE]: retrosynthesisRouteMapper,
  [RsRoute.PROJECT_ROUTE_TREE_VIEW]: retrosynthesisRouteMapper,
};

export function setPageTitle({ title, pageName }) {
  const section1 = compact([pageName, brandName]).join(' | ');
  document.title = compact([section1, title]).join(' - ');
}

export async function processReactRoute(route = {}) {
  const { path, params } = route;
  try {
    const { title, pageName } = await get(ReactRouteMapper, path, () => ({}))(params);
    setPageTitle({ title, pageName });
  } catch (e) {
    Logger.info('Page title ignored for route: ', path, e);
  }
}
